import { HasLatLong, VehicleResponse } from "types/trip.types";
// import { VehicleEnum } from '../store/config/enums/vehicle.enum';
// Replace moment with dayjs and plugins
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { CustomerResponse } from "types/responses.type";
dayjs.extend(utc);
dayjs.extend(timezone);

export const vehicleListConcat = (vehicle: VehicleResponse): string => {
  if (vehicle) {
    switch (vehicle.vehicleType) {
      case "BIKE":
      case "WALKER":
        return vehicle.vehicleType;
      default:
        let returnValue = "";
        returnValue += vehicle.vehicleType ? `${vehicle.vehicleType}-` : "";
        returnValue += vehicle.model ? `${vehicle.model}-` : "";
        returnValue += vehicle.color ? `${vehicle.color}-` : "";
        returnValue += vehicle.licensePlate ? `${vehicle.licensePlate}` : "";
        return returnValue;
    }
  } else {
    return "N/D";
  }
};

export const googleMapsLink = (location: HasLatLong): string => {
  if (location) {
    const latitude = location.latitude;
    const longitude = location.longitude;
    return `https://maps.google.com/?q=${latitude},${longitude}`;
  } else {
    return "N/D";
  }
};

export const maskPhone = (phone: string | undefined) => {
  if (phone?.length === 10) {
    return `(${phone[0]}${phone[1]}${phone[2]}) ${phone[3]}${phone[4]}${phone[5]}-${phone[6]}${phone[7]}${phone[8]}${phone[9]}`;
  }
};

export const formatTime = (time: string | null): string | null => {
  if (time) {
    const timeObj = new Date(" 2000/01/01 " + time);
    const hours = (
      timeObj.getHours() > 12 ? timeObj.getHours() - 12 : timeObj.getHours()
    ).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
    const amPm = timeObj.getHours() >= 12 ? " pm" : " am";
    return (
      hours +
      ":" +
      timeObj.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      amPm
    );
  }
  return null;
};

export const formatTimeWindow = (
  from: string | null,
  to: string | null,
  replaceNullWithText: boolean = false
) => {
  if (!from && !to) return replaceNullWithText ? <div>Whole day</div> : null;
  if (replaceNullWithText)
    return (
      <div className="time-window time-window-text">
        {(from ? formatTime(from) + (to ? " to" : "") : "Before") +
          " " +
          (to ? formatTime(to) : "and later")}
      </div>
    );
  else
    return (
      <>
        <div className="time-window time-window-from">
          {formatTime(from ?? "00:00:00")}
        </div>
        <div className="time-window time-window-to">
          {formatTime(to ?? "23:59:00")}
        </div>
      </>
    );
};

export const replaceVariableNameByItsValue = (
  body: string,
  variablesObject: any
): string => {
  let replacedStr = body;
  if (variablesObject && Object.keys(variablesObject).length) {
    let variables = body.match(/{[a-zA-Z0-9._]+}/g);
    if (Array.isArray(variables)) {
      variables.forEach((variable) => {
        const variableIndexes = variable
          .substring(1, variable.length - 1)
          .split(".")
          .map((indexName) => indexName.trim());
        let value: any = variablesObject;
        let idx = 0;
        do {
          value = value[variableIndexes[idx++]] ?? null;
        } while (idx < variableIndexes.length);
        if (value)
          replacedStr = replacedStr.replaceAll(variable, value.toString());
      });
    }
  }
  return replacedStr;
};

export const formatDate = (
  date: string | Date,
  calendarDate: boolean = false,
  attachTime: boolean = false
): string => {
  let dateString = dayjs(date).format("MM/DD/YYYY");
  if (calendarDate) {
    const currentDate = new Date();
    const targetDate = new Date(date);

    if (date)
      if (currentDate.getFullYear() == targetDate.getFullYear()) {
        if (currentDate.getMonth() == targetDate.getMonth()) {
          if (currentDate.getDate() == targetDate.getDate()) {
            return "Today " + dayjs(targetDate).format("h:mm a");
          } else if (currentDate.getDate() + 1 == targetDate.getDate()) {
            return "Tomorrow";
          }
          return dayjs(targetDate).format("Do");
        }
        return dayjs(targetDate).format("MMM Do");
      }
  }
  if (attachTime) dateString += attachTime ? " " + timePart(date) : "";
  return dateString;
};

export const FormatDateByTimezone = (date: Date, timezoneStr?: string) => {
  if (timezoneStr) dayjs.tz.setDefault(timezoneStr);
  return dayjs(date).format("MM/DD/YY");
};

export const FormatRelatedDateTimeByTimezone = (
  date: Date | undefined,
  pivotDate: Date | undefined,
  timezoneStr?: string
) => {
  if (timezoneStr) dayjs.tz.setDefault(timezoneStr);
  return (
    (dayjs(date).isSame(pivotDate, "day")
      ? ""
      : dayjs(date).format("MM/DD - ")) + dayjs(date).format("HH:mm")
  );
};

export const descriptionalTime = (date?: Date, timezoneStr?: string) => {
  if (!date) return "Time not available";
  const minutes = dayjs().diff(dayjs(date), "minute");
  if (minutes < 1) return "Now";
  if (minutes < 2) return "A minute ago";
  if (minutes < 60) return `${minutes} minutes ago`;
  if (timezoneStr) dayjs.tz.setDefault(timezoneStr);
  if (dayjs().isSame(dayjs(date), "day")) {
    const hours = dayjs().diff(dayjs(date), "hour");
    return `${hours} hour${hours >= 2 ? "s" : ""} ago`;
  } else {
    return `${dayjs(date).format("DD/MM/YY")}`;
  }
};

export const fixNumber = (n: number = 0) => +n.toFixed(2);

export const strOrAlt = (
  str: string | undefined,
  alt: string | undefined,
  defaultStr?: string
) => (str ? str : alt ? alt : defaultStr);

export const fixBigNumber = (n: number = 0) => {
  let postfix = "";
  if (n >= 1000000) {
    n /= 1000000;
    postfix = "M";
  } else if (n >= 1000) {
    n /= 1000;
    postfix = "K";
  }
  return `${n.toFixed(1)} ${postfix}`;
};

export const getCustomerDisplayName = (customer: CustomerResponse) => {
  return customer.companyName
    ? customer.companyName
    : `${customer.displayName ?? ""}`;
};

export const formatMinutes = (
  minutes: number,
  approximate: boolean = false
) => {
  if (minutes < 60) {
    return minutes.toFixed(0) + "'";
  } else if (minutes < 60 * 24) {
    let hours = Math.floor(minutes / 60);
    let remaining = minutes - hours * 60;
    if (approximate) {
      hours += Math.round(remaining / 60);
      remaining = 0;
    }
    return remaining == 0
      ? hours + "h"
      : hours + "h " + remaining.toFixed(0) + "'";
  } else {
    const days = Math.floor(minutes / (24 * 60));
    return days + "d";
  }
};

export const timePart = (date: Date | string) => dayjs(date).format("h:mm a");

export function convertConstantLiteralToNormal(input?: string): string {
  if (input) {
    let words = input.toLowerCase().split("_");
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i][0].toUpperCase() + words[i].slice(1);
    }
    return words.join(" ");
  } else return "";
}

export function isValidEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getPasswordProblems(password: string) {
  const requirements =
    "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character";
  if (
    !password ||
    password.length < 8 ||
    !/[A-Z]/.test(password) ||
    !/[a-z]/.test(password) ||
    !/[0-9]/.test(password) ||
    !/[^A-Za-z0-9]/.test(password)
  ) {
    return requirements;
  }

  return null;
}
